.item {
	font-weight: bold;
	background: #eee;
	padding: 2px 8px;
	border: 1px solid #ccc;
}

.item:focus,
.item:focus-within {
	outline: none;
	color: white;
	background: rgb(244, 63, 94);
	border-color: rgb(244, 63, 94);
}
